export default __webpack_public_path__ + "static/media/Snd5.861d106c.mp3";